/**
 * This component is the common campaign volunteer component
 */
import axios from 'axios';
import globals from '../../common/globals';
import googleMapsMixin from '../../common/mixins/google-maps-mixin';
import vxMarketingFormNorender from '../../common/vx-marketing-form/norender/vx-marketing-form-mixin';

export default {
  name: 'vx-campaign-volunteer-match',
  components: { },
  props: {
  },
  mixins: [vxMarketingFormNorender, googleMapsMixin],
  data() {
    return {
      globals,
      zipCode: null,
      zipCodePH: 'Enter Your Zip Code',
      isUserZip: false,
      gettingLocation: false,
      foundGeoLoc: true,
      isGettingVMData: false,
      nextPage: 1,
      resultsSize: 0,
      lastPage: 1,
      PAGE_SIZE: 100,
      mapArray: [],
      markers1: [],
      markers2: [],
      oppsOnMap: [],
      currentOpp: null,
      currentRequirements: [],
      currentSkills: [],
      currentCauseArea: [],
      currentCustomFields: [],
      headerText: 'TAKE ACTION',
      subHeaderText: 'Find the cause you believe in and join us in taking action',
      iconConfig: {
        pinColor1: 'cc092f',
      },
      API_URL: '/gpcommercewebservices/v2/gppro/apiproxy',
      remoteURL: '/graphql',
      vmResponseData: null,
      oppsArray: [],
      INITIAL_MARKER_COUNT: 5,
      INCR_OPPSLIST_VAL: 4,
      oppIDsVisited: [],
      connectionFailed: false,
    };
  },
  computed: {},
  mounted() {
    this.$on('mapMounted', () => {
      this.initMap(this.google, 'map-canvas-1');
    });
  },
  methods: {
    /* eslint no-undef: "error" */

    /**
     * Intitialize Google maps component
     * @param  {Object} google google maps object
     * @param  {Object} mapID div element id for cooresponding map
     */
    initMap(google, mapID) {
      const featureOpts = [{
        stylers: this.mapTheme,
      }];

      const mapOptions = {
        center: {
          lat: this.makerDefaultLocation.lat,
          lng: this.makerDefaultLocation.lng,
        },
        zoom: 15,
        zoomControl: true,
        minZoom: 1,
        scrollwheel: true,
      };
      let mapArrayIndex = 0;
      switch (mapID) {
        case 'map-canvas-1':
          mapArrayIndex = 0;
          break;
        case 'map-canvas-3':
          mapArrayIndex = 2;
          break;
        default:
      }
      // map array holds each instance of the google maps being used
      this.mapArray[mapArrayIndex] = new google.maps.Map(
        document.getElementById(mapID),
        mapOptions,
      );
      this.mapArray[mapArrayIndex].setOptions({
        styles: featureOpts,
      });
      this.mapLoaded(mapID);
    },

    /**
     * Called after map has been initialized
     * @param  {Object} mapID div element id for cooresponding map
     */
    mapLoaded(mapID) {
      if (mapID === 'map-canvas-1' && this.oppsArray.length === 0) {
        if (!('geolocation' in navigator)) {
          return;
        }
        this.gettingLocation = true;
        navigator.geolocation.getCurrentPosition((pos) => {
          this.gettingLocation = false;
          const location = {};
          location.lat = pos.coords.latitude;
          location.lng = pos.coords.longitude;
          this.reverseGeoCode(location);
        }

          , () => {
          this.gettingLocation = false;
          this.foundGeoLoc = false;
        });
      } else if (mapID === 'map-canvas-1' && this.oppsArray.length > 0) {
        // when map is reinitialized after returning from opp details page
        for (let i = 0; i <= this.oppsOnMap.length - 1; i++) { this.addOppToMap(this.oppsOnMap[i]); }
      } else { // add marker for mini map on opp details page
        this.createMarker(
          this.currentOpp.title,
          this.oppsArray.indexOf(this.currentOpp) + 1,
          this.currentOpp.location.geoLocation.latitude,
          this.currentOpp.location.geoLocation.longitude,
          2,
        );
      }
    },
    /**
     * Takes lat/lng values and parses zipcode info from address object response, adds location marker to map
     * @param  {Object} loc contains latitude and longitude values
     */

    reverseGeoCode(loc) {
      const self = this;
      axios.post(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${loc.lat},${loc.lng}&key=${this.globals.googleMapsKey}`)
        .then((response) => {
          const addressComponents = response.data.results[0].address_components;

          for (let i = 0; i <= addressComponents.length - 1; i++) {
            if (addressComponents[i].types[0] === 'postal_code') {
              self.zipCodePH = response.data.results[0].address_components[i].long_name;
              document.getElementById('zip').style.fontSize = '3.5rem';
              break;
            }
          }
          const gpsMarker = this.createMarker(
            '',
            '',
            loc.lat,
            loc.lng,
            0,
          );
          this.markers1.push(gpsMarker);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * Returns vm opportunity info based on zip
     * @param  {Object} origin identifies where and what context create connection was called from
     */
    vmCreateConnection(origin) {
      if ((origin === 'btn' && this.zipCode && this.zipCode.length === 5) || origin === 'result') {
        this.connectionFailed = false;
        this.isGettingVMData = true;
        this.nextPage = origin === 'btn' ? 1 : this.nextPage;
        const request = {
          remoteName: 'VolunteerMatch',
          remoteUrl: this.remoteURL,
          remoteHeaders: ['X-api-key:{$remote_access_token}', 'Content-Type:application/json', 'host:graphql.stage.volunteermatch.org', 'Accept:*/*'],
          postData: `{ \"query\" : \"query { searchOpportunities (input : { location : \\\"${this.zipCode || this.zipCodePH}\\\",sortCriteria: distance,pageNumber: ${this.nextPage}} ) { currentPage resultsSize numberOfResults opportunities { id title description imageUrl categories tags skillsNeeded dateRange { endDate endTime ongoing singleDayOpps startDate startTime } url greatFor groupSize volunteersNeeded customFields { fieldId fieldLabel fieldType required choices } requirements { bgCheck drLicense minimumAge orientation } shifts { date endTime id name notes startTime volNeeded } location { city region country postalCode region street1 street2 virtual geoLocation { accuracy latitude longitude } } parentOrg { name } } } } \" }`,
        };


        this.GetAuthToken((success) => {
          if (success) {
            const timer = setTimeout(this.serverTimer, 20000);
            const options = {
              headers: {
                Authorization: `bearer ${this.config.access_token}`,
                'Content-Type': 'application/json',
              },
            };
            axios.post(
              this.API_URL,
              request,
              options,
            ).then((response) => {
              clearTimeout(timer);
              this.isGettingVMData = false;
              if (!this.vmResponseData || origin === 'btn') {
                this.vmResponseData = JSON.parse(response.data).data;
                this.resultsSize = this.vmResponseData.searchOpportunities.resultsSize;
                // calculates how many pages of opps there are, ie how many calls we can make
                this.lastPage = Math.ceil(this.resultsSize / this.PAGE_SIZE);
                this.oppsListBuilder('zip');
              } else {
                const vmOpportunities = this.vmResponseData.searchOpportunities.opportunities;
                this.vmResponseData.searchOpportunities.opportunities = vmOpportunities.concat(JSON.parse(response.data).data.searchOpportunities.opportunities);
                const currentIndex = this.oppsArray.length;
                for (let i = currentIndex; i < currentIndex + this.INCR_OPPSLIST_VAL; i++) {
                // add INCR_OPPSLIST_VAL amount of opps to oppslist when scrolled to bottom of container
                  if (this.vmResponseData.searchOpportunities.opportunities[i] && this.oppsArray.indexOf(this.vmResponseData.searchOpportunities.opportunities[i]) === -1) {
                    this.oppsArray.push(this.vmResponseData.searchOpportunities.opportunities[i]);
                  }
                }
              }
              this.nextPage += 1;
            }).catch((error) => {
              this.isGettingVMData = false;
              this.connectionFailed = true;
            });
          }
        });
      }
    },

    /**
     * Builds the scrollable list of opportunities
     * @param  {Object} origin identifies where and what context method was called from
     */
    oppsListBuilder(origin) {
      let lastOppId = null;
      this.markers2 = [];
      if (origin === 'zip') {
        // if arriving from the zipcode handler then reset everything, add new markers
        const markersCount = this.INITIAL_MARKER_COUNT;
        this.oppsOnMap = [];
        this.oppsArray = [];
        this.mapArray[1] = null;
        for (let i = 0; i < markersCount; i++) {
          this.oppsArray.push(this.vmResponseData.searchOpportunities.opportunities[i]);
          this.oppsOnMap.push(this.vmResponseData.searchOpportunities.opportunities[i]);
        }
      } else {
        // if coming from opp details page map shouldn't change
        lastOppId = this.currentOpp.id;
        this.currentOpp = null;
      }
      this.currentRequirements = [];
      this.currentSkills = [];
      this.currentCauseArea = [];
      this.currentCustomFields = [];

      this.$nextTick(function() {
        // after map/list is rendered
        if (this.markers1[0]) {
          this.markers1[0].setVisible(false);
        }
        const el = document.getElementById('oppsListContainer');
        if (el) {
          el.addEventListener('scroll', (e) => {
            if (Math.abs(el.scrollHeight - el.scrollTop - el.clientHeight) <= 3) {
              // handle scrolling to the bottom of container
              const currentIndex = this.oppsArray.length;
              if (this.oppsArray.length < this.vmResponseData.searchOpportunities.opportunities.length) {
                for (let i = currentIndex; i < currentIndex + this.INCR_OPPSLIST_VAL; i++) {
                  // add INCR_OPPSLIST_VAL amount of opps to oppslist when scrolled to bottom of container
                  if (this.vmResponseData.searchOpportunities.opportunities[i] && this.oppsArray.indexOf(this.vmResponseData.searchOpportunities.opportunities[i]) === -1) {
                    this.oppsArray.push(this.vmResponseData.searchOpportunities.opportunities[i]);
                  }
                }
              } else if (this.oppsArray.length === this.vmResponseData.searchOpportunities.opportunities.length) {
                if (this.nextPage <= this.lastPage) {
                  // no more calls after the last possible page
                  if (!this.isGettingVMData) {
                    this.vmCreateConnection(origin);
                  }
                }
              }
            }
          });
        }

        if (origin === 'results') {
          // if coming from details page
          for (let i = 0; i <= this.oppIDsVisited.length - 1; i++) {
            if (document.getElementById(this.oppIDsVisited[i])) {
              document.getElementById(this.oppIDsVisited[i]).style.backgroundColor = '#555555';
            }
          }
          this.initMap(this.google, 'map-canvas-1');
          if (this.markers1[0]) {
            this.markers1[0].setVisible(false);
          }
          const elmnt = document.getElementById(lastOppId);
          elmnt.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          // autoscroll to the last opp element that was clicked on
        } else {
          this.oppIDsVisited = [];
          this.subHeaderText = `CAUSES NEAR ${this.zipCode || this.zipCodePH}: <u>${this.vmResponseData.searchOpportunities.resultsSize}</u>`;
          for (let i = 0; i <= this.oppsArray.length - 1; i++) { this.addOppToMap(this.oppsArray[i]); }
        }
      });
    },

    /**
     * Adds each opps coooresponding map marker, bounce when hovered
     * @param  {Object} opp opportunity object
     */
    mouseOver(opp) {
      if (this.oppsOnMap.indexOf(opp) === -1) {
        this.oppsOnMap.push(opp);
        this.addOppToMap(opp);
      }
      const hoveredMarker = this.markers2[this.oppsOnMap.indexOf(opp)];
      hoveredMarker.setAnimation(this.google.maps.Animation.BOUNCE);
    },

    /**
     * cancel bounce annimation
     * @param  {Object} opp opportunity object
     */
    mouseOut(opp) {
      const hoveredMarker = this.markers2[this.oppsOnMap.indexOf(opp)];
      hoveredMarker.setAnimation(-1);
    },
    /**
     * Makes markers
     * @param  {String} label label value
     * @param  {Number} iconNum   icon number
     * @param  {Number} lat   latitude value
     * @param  {Number} lng   longitude value
     * @param  {Number} mapArrayIndex  index of map to add marker
     * @return {Object} returns marker object
     */
    createMarker(label, iconNum, lat, lng, mapArrayIndex) {
      const position = new this.google.maps.LatLng(lat, lng);
      this.mapArray[mapArrayIndex].setCenter(position);
      this.mapArray[mapArrayIndex].setZoom(11);
      this.mapArray[mapArrayIndex].panTo(position);

      const marker = new this.google.maps.Marker({
        map: this.mapArray[mapArrayIndex],
        position,
        title: label,
        animation: this.google.maps.Animation.DROP,
        icon: `//chart.apis.google.com/chart?chst=d_map_pin_letter&chld=${iconNum}|${this.iconConfig.pinColor1}|ffffff`,

      });
      if (this.markers1.length) {
        marker.addListener('click', () => {
          this.setCurrentOpp(this.oppsArray[iconNum - 1]);
        });
      }
      return marker;
    },

    /**
     * Add opp's marker to map
     * @param  {Object} opp opportunity object
     */
    addOppToMap(opp) {
      const location = opp.location;
      const newMarker = this.createMarker(
        opp.title,
        (this.oppsArray.indexOf(opp) + 1).toString(),
        location.geoLocation.latitude,
        location.geoLocation.longitude,
        0,
      );
      this.markers2.push(newMarker);

      this.markers2[this.markers2.length - 1].setMap(this.mapArray[0]);

      const bounds = new this.google.maps.LatLngBounds();
      for (let i = 0; i <= this.markers2.length - 1; i++) {
        bounds.extend(this.markers2[i].getPosition());
      }
      this.mapArray[0].fitBounds(bounds);
    },

    /**
     * Handle's scenario of when an opp is selected
     * @param  {Object} opp opportunity object
     */
    setCurrentOpp(opp) {
      this.currentOpp = opp;
      this.oppIDsVisited.push(opp.id);
      if (document.getElementById(opp.id)) {
        document.getElementById(opp.id).style.backgroundColor = '#555555';
      }
      this.currentSkills = [];
      this.currentRequirements = [];
      this.currentCustomFields = [];
      const skills = opp.skillsNeeded.split(';');
      if (skills.length > 1) {
        skills.splice(skills.length - 1, 1);
      }
      this.currentSkills = skills;
      this.currentCustomFields = opp.customFields;


      const rawReq = Object.values(opp.requirements);

      for (let i = 0; i <= rawReq.length - 1; i++) {
        const val = rawReq[i];
        switch (i) {
          case 0:
            if (val) { this.currentRequirements.push('Background Check'); }
            break;
          case 1:
            if (val) { this.currentRequirements.push('Driver\'s License'); }
            break;
          case 3:
            if (val) { this.currentRequirements.push('Orientation'); }
            break;
          default:
        }
      }

      this.$nextTick(function() {
        document.getElementById('prev').style.visibility = 'visible';
        document.getElementById('next').style.visibility = 'visible';
        if (this.oppsArray.indexOf(opp) === 0) {
          document.getElementById('prev').style.visibility = 'hidden';
        } if (this.oppsArray.indexOf(opp) === this.oppsArray.length - 1) {
          document.getElementById('next').style.visibility = 'hidden';
        }
        this.initMap(this.google, 'map-canvas-3');
      });
    },

    /**
     * Handles next/forward/return clicks on details page nav
     * @param  {String} direction specifies user's desired next state
     */
    pagination(direction) {
      const oppIndex = this.oppsArray.indexOf(this.currentOpp);
      switch (direction) {
        case 'results':
          this.oppsListBuilder('results');
          break;
        case 'prev':
          this.setCurrentOpp(this.oppsArray[oppIndex - 1]);
          break;
        case 'next':
          this.setCurrentOpp(this.oppsArray[oppIndex + 1]);
          break;
        default:
      }
    },

    /**
     * Handles interactivity of the zip search
     * @param  {Object} event specifies user's interaction with zipcode search
     */
    zipCodeHandler(event) {
      if (this.zipCodePH && !this.zipCode && event === 'mouseenter' && !this.isUserZip && this.foundGeoLoc) {
        this.zipCode = this.zipCodePH;
      } else if (this.zipCodePH && this.zipCode && event === 'mouseleave' && !this.isUserZip && this.foundGeoLoc) {
        this.zipCode = null;
      } else if (event === 'userChanged') {
        if (this.foundGeoLoc && this.markers1[0]) {
          this.markers1[0].setVisible(false);
        }

        document.getElementById('zip').style.fontSize = '3.5rem';
        this.isUserZip = !!this.zipCode;
        if (this.zipCode.length > 5) {
          const str = this.zipCode;
          this.zipCode = str.substring(0, 5);
        } else if (this.zipCode.length === 5) {
          if (!this.foundGeoLoc) {
            this.$nextTick(() => {
              this.initMap(this.google, 'map-canvas-1');
              this.$nextTick(() => {
                this.changeZipMap(this.zipCode);
              });
            });
          } else {
            this.changeZipMap(this.zipCode);
          }
        } else if (this.zipCode.length === 0 && !this.foundGeoLoc) {
          document.getElementById('zip').style.fontSize = '2rem';
          if (this.markers1[0]) {
            this.markers1[0].setVisible(true);
          }
        } else if ((this.zipcode && this.zipcode.length === 0) || (this.zipcodePH && this.zipcodePH.length === 0)) {
          if (this.markers1[0]) {
            this.markers1[0].setVisible(true);
          }
        }
        this.oppsArray = [];
      } else if (event === 'backBtn') {
        if (this.markers1[0]) {
          this.markers1[0].setVisible(true);
        } this.oppsArray = [];
        this.markers2 = [];
        this.subHeaderText = 'Find the cause you believe in and join us in taking action';
        this.connectionFailed = false;
        this.$nextTick(() => {
          this.initMap(this.google, 'map-canvas-1');

          document.getElementById('zip').style.fontSize = '3.5rem';
        });
        if (!this.foundGeoLoc) {
          this.zipCode = null;
          this.$nextTick(() => {
            document.getElementById('zip').style.fontSize = '2rem';
          });
        }
      }
    },

    /**
     * Changes map after user enters a 5 digit zip
     * @param  {String} zipCode zipcode value
     */
    changeZipMap(zipCode) {
      const geocoder = new self.google.maps.Geocoder();
      geocoder.geocode({ address: zipCode.toString() }, (results, status) => {
        if (status === this.google.maps.GeocoderStatus.OK) {
          if (this.markers1[0]) {
            this.markers1[0].setMap(null);
          }
          this.markers1.length = 0;
          this.mapArray[0].setCenter(results[0].geometry.location);
          const marker = new this.google.maps.Marker({
            map: this.mapArray[0],
            position: results[0].geometry.location,
            title: zipCode,
            animation: this.google.maps.Animation.DROP,
            icon: `//chart.apis.google.com/chart?chst=d_map_pin_letter&chld=${''}|${this.iconConfig.pinColor1}|ffffff`,
          });
          this.markers1.push(marker);
        } else {
          alert('Zipcode not found!');
        }
      });
    },

    /**
     * Calculates how long user has been waiting for a response
     */
    serverTimer() {
      this.isGettingVMData = false;
      this.connectionFailed = true;
    },

    /**
     * Changes map after user enters a 5 digit zip
     * @param  {String} attr attribute distinction value
     * @param  {String} category icon category value
     * @return {String} class name or tooltip value
     */
    getCauseIcons(attr, category) {
      let index = '';
      let tooltip = '';
      switch (category) {
        case 'advocacyAndHumanRights':
          index = 23;
          tooltip = 'Advocacy & Human Rights';
          break;
        case 'animals':
          index = 30;
          tooltip = 'Animals';

          break;
        case 'artsAndCulture':
          index = 34;
          tooltip = 'Arts & Culture';

          break;
        case 'boardDevelopment':
          index = 38;
          tooltip = 'Board Development';

          break;
        case 'childrenAndYouth':
          index = 22;
          tooltip = 'Children & Youth';

          break;
        case 'community':
          index = 25;
          tooltip = 'Community';

          break;
        case 'computersAndTechnology':
          index = 37;
          tooltip = 'Computers & Technology';

          break;
        case 'crisisSupport':
          index = 14;
          tooltip = 'Crisis Support';

          break;
        case 'disabled':
          index = 17;
          tooltip = 'People with Disabilities';

          break;
        case 'disasterRelief':
          index = 42;
          tooltip = 'Disaster Relief';

          break;
        case 'educationAndLiteracy':
          index = 15;
          tooltip = 'Education & Literacy';

          break;
        case 'emergencyAndSafety':
          index = 28;
          tooltip = 'Emergency & Safety';

          break;
        case 'employment':
          index = 27;
          tooltip = 'Employment';

          break;
        case 'environment':
          index = 13;
          tooltip = 'Environment';

          break;
        case 'gayLesbianBiTrans':
          index = 31;
          tooltip = 'LGBTQ+';

          break;
        case 'healthAndMedicine':
          index = 11;
          tooltip = 'Health & Medicine';

          break;
        case 'homelessAndHousing':
          index = 7;
          tooltip = 'Homeless & Housing';

          break;
        case 'hunger':
          index = 39;
          tooltip = 'Hunger';

          break;
        case 'immigrantsAndRefugees':
          index = 41;
          tooltip = 'Immigrants & Refugees';

          break;
        case 'international':
          index = 29;
          tooltip = 'International';

          break;
        case 'justiceAndLegal':
          index = 5;
          tooltip = 'Justice & Legal';

          break;
        case 'mediaAndBroadcasting':
          index = 40;
          tooltip = 'Media & Broadcasting';

          break;
        case 'politics':
          index = 6;
          tooltip = 'Politics';

          break;
        case 'raceAndEthnicity':
          index = 33;
          tooltip = 'Race & Ethnicity';

          break;
        case 'religion':
          index = 36;
          tooltip = 'Faith-Based';

          break;
        case 'seniors':
          index = 12;
          tooltip = 'Seniors';

          break;
        case 'sportsAndRecreation':
          index = 19;
          tooltip = 'Sports & Recreation';

          break;
        case 'veteransAndMilitaryFamilies':
          index = 43;
          tooltip = 'Veterans & Military Families';

          break;
        case 'women':
          index = 3;
          tooltip = 'Women';

          break;
        default:
      }
      if (attr === 'classAttr') {
        return `cat_icon cause_area_icons_md icon_category_31x31_${index}`;
      } else if (attr === 'tooltipAttr') {
        return tooltip;
      }
      return '';
    },
  },

};



// WEBPACK FOOTER //
// ./src/components/campaigns/vx-campaign-volunteer-match/vx-campaign-volunteer-match.js